export enum ApiStatus {
  'loading',
  'success',
  'error',
}
